module.exports = __webpack_public_path__ + "img/scannerSave_02.4e7f21ec.png";